<template>
    <div class="hot">
        <span>热门视频</span>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>